import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { Segment, VerticalSpacer } from './../core/core';
import PrimaryButton from './../components/PrimaryButton/PrimaryButton';
import progressReportScreenshot from '../images/example-mypeekaville-progress-report.png';
import styles from './../SCSS/ClassroomDashboard.module.scss';
import utilityStyles from './../SCSS/common/utilityStyles.module.scss';
import segmentStyles from './../SCSS/Segment.module.scss';

const MarketingProgressReport = () => {
  const history = useHistory();
  return (
    <div className={`${styles.ClassroomDashboard} ${utilityStyles.clearfix}`}>
      <VerticalSpacer ems={2} />
      <Segment className={utilityStyles.line}>
        <div className={segmentStyles.moduleTitle}>myPeekaville Progress Report Example</div>
      </Segment>
      <Segment className={utilityStyles.line}>
        <div className={styles.marketingCopy}>
          <p>
            With Peekapak’s interactive learning game, myPeekaville, students check-in with their feelings, help
            characters through quests and read stories, while providing educators with student-specific progress and
            comprehension data used to better support student learning.
          </p>
          <p>
            myPeekaville uses story-based learning, exciting games, an immersive world, engaging narration, and
            beautiful visuals to bring learning to life. To access myPeekaville, please upgrade to the Peekapak PRO
            subscription:
          </p>
          <div className='ctaButton'>
            <PrimaryButton onClick={() => history.push('/features')}>Upgrade Now</PrimaryButton>
          </div>
        </div>
        <img
          alt='Screenshot'
          className={cx(utilityStyles.marketingScreenshot, styles.marketingImg)}
          src={progressReportScreenshot}
        />
      </Segment>
    </div>
  );
};

export default MarketingProgressReport;
